
import { Button } from "@/components/ui/button";
import { Users, Phone, CheckSquare } from "lucide-react";


const BonusesSection = () => {
  
  
  const bonuses = [
    {
      title: "Liberated Consultant Community",
      description: "Get an invite to the exclusive community dedicated for independent consultants to support eachother, share ideas, and refer projects.",
      icon: <Users className="h-12 w-12 text-book-yellow" />
    },
    {
      title: "Quick Start Coaching Call",
      description: "Get a free 30 minute coaching call with Rey Marques to help you jump start your move to independence or accelerate it if you're currently independent. For a limited time.",
      icon: <Phone className="h-12 w-12 text-book-yellow" />
    },
    {
      title: "Productivity Tool Access",
      description: "A special invitation to use the custom consulting software I developed for my team and I to use to overbook more successfully.",
      icon: <CheckSquare className="h-12 w-12 text-book-yellow" />
    }
  ];

  return (
    <section className="light-section">
      <div className="container mx-auto px-4">
        <h2 className="section-title">
          Claim Your FREE Copy Right Now And You'll<br className="hidden md:block"/>
          Immediately Receive These Bonuses
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-12">
          {bonuses.map((bonus, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden border border-amber-200">
              <div className="h-32 bg-gradient-to-r from-amber-500/20 to-amber-700/30 flex items-center justify-center p-4">
                {bonus.icon}
              </div>
              <div className="p-4">
                <h3 className="font-bold text-lg mb-2 text-book-darkBg">{bonus.title}</h3>
                <p className="text-gray-600 text-sm">{bonus.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BonusesSection;
